import { HomeScreenThemeSizeConfig } from './types';

const large: HomeScreenThemeSizeConfig = {
  homeScreen: {},
};

export default large;
